import {RelayPaginationState} from "../../pagination";
import {SortBy} from "../../../common";
import {tryFormatLocalDate} from "../../../common/util/date";
import {ProviderMetricsReportTypeMap} from "../domain";

export type ProviderMetricInfo = {
    guid: string;
    reportName: string;
    reportType: string;
    reportPeriodStart: string;
    reportPeriodEnd: string;
    _reportPeriod: string;
    reportAvailableDate: string;
    documentLink: string;
}

export type ProviderMetricsPageState = {
    pagination: RelayPaginationState;
    filter: ProviderMetricsFilterValue;
    showSubmitInquiryModal: boolean,
    pageSize: number;
    sortBy: SortBy<ProviderMetricInfo>;
}

export type  ProviderMetricsFilterValue = {
    reportType: string;
    reportPeriod: Date | null;
    reportAvailableDateFrom: Date | null;
    reportAvailableDateTo: Date | null;
}
export function asQueryParam(filter: ProviderMetricsFilterValue) {
    return {
        reportType: filter.reportType === "" || !ProviderMetricsReportTypeMap.has(filter.reportType) ? null : filter.reportType,
        reportPeriod: tryFormatLocalDate(filter.reportPeriod ?? null),
        reportAvailableDateFrom: tryFormatLocalDate(filter.reportAvailableDateFrom ?? null),
        reportAvailableDateTo: tryFormatLocalDate(filter.reportAvailableDateTo ?? null),
    };
}
